import React, { useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { Card, CardBody, Col, Container, Row, Spinner, Alert } from "reactstrap"
import { verifikasiSecret } from "../../services/authService" // sesuaikan path import

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"

const KonfirmasiEmail = () => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const secret = queryParams.get("secret")

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [message, setMessage] = useState("")

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await verifikasiSecret(secret)
        console.log("API success:", res)

        if (res.success) {
          setMessage(res.message || "Verifikasi berhasil.")
        } else {
          setError(res.message || "Verifikasi gagal.")
        }
      } catch (err) {
        console.error("API error:", err)
        setError(err.response?.data?.message || "Verifikasi gagal, coba lagi.")
      } finally {
        setLoading(false)
      }
    }

    if (secret) {
      verify()
    } else {
      setError("Secret tidak ditemukan di URL")
      setLoading(false)
    }
  }, [secret])

  document.title = "Confirm Mail | ASN Kedinasan Learning Center"

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="d-block text-center mb-5 text-muted">
                <Link to="/dashboard" className="d-block auth-logo">
                  <img
                    src={logodark}
                    alt=""
                    height="20"
                    className="auth-logo-dark mx-auto"
                  />
                  <img
                    src={logolight}
                    alt=""
                    height="20"
                    className="auth-logo-light mx-auto"
                  />
                </Link>
                <p className="mt-3">ASN Kedinasan Learning Center</p>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2 text-center">
                    {/* Loading spinner */}
                    {loading && <Spinner color="primary" />}

                    {/* Success case */}
                    {!loading && message && !error && (
                      <>
                        <div className="avatar-md mx-auto">
                          <div className="avatar-title rounded-circle bg-light">
                            <i className="bx bx-mail-send h1 mb-0 text-primary"></i>
                          </div>
                        </div>
                        <div className="p-2 mt-4">
                          <h4>Success!</h4>
                          <p className="text-muted">{message}</p>
                          <div className="mt-4">
                            <Link to="/login" className="btn btn-success">
                              Back to Login
                            </Link>
                          </div>
                        </div>
                      </>
                    )}

                    {/* Error case */}
                    {!loading && error && (
                      <div className="p-2 mt-4">
                        <Alert color="danger">{error}</Alert>
                        <div className="mt-4">
                          <Link to="/login" className="btn btn-primary">
                            Back to Login
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} ASN Kedinasan Learning Center{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default KonfirmasiEmail
